import { styled } from 'styled-system/jsx'

const Shell = styled('main', {
  base: {
    minHeight: '100vh',
    backgroundColor: 'app.bg',
    color: 'app.fg',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
    gap: '12px',
    textAlign: 'center',
  },
})

const Title = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '64px',
    fontWeight: 700,
    color: 'app.accent',
    margin: 0,
    lineHeight: 1,
  },
})

const Subtitle = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
    maxWidth: '420px',
  },
})

export { Shell, Title, Subtitle }
